import React from 'react';
//import { Button, Input } from 'antd';
import { getLoginDomain } from 'src/tools/getUserInfo';

const Test = (props) => {
  React.useEffect(() => {
    const d = getLoginDomain();
    window.location.href = `${d}/login`;
  }, []);
  return <div>not Login</div>;
};
export default Test;
